/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';
import type { NullableMoneyOutput } from './NullableMoneyOutput';
import {
    NullableMoneyOutputFromJSON,
    NullableMoneyOutputFromJSONTyped,
    NullableMoneyOutputToJSON,
    NullableMoneyOutputToJSONTyped,
} from './NullableMoneyOutput';

/**
 * 
 * @export
 * @interface ProductProfitabilityProductData
 */
export interface ProductProfitabilityProductData {
    /**
     * 
     * @type {string}
     * @memberof ProductProfitabilityProductData
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductProfitabilityProductData
     */
    integrationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductProfitabilityProductData
     */
    productRemoteId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilityProductData
     */
    amount?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductProfitabilityProductData
     */
    turnover?: MoneyOutput;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ProductProfitabilityProductData
     */
    purchasePrice?: NullableMoneyOutput | null;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilityProductData
     */
    purchaseCostUnknownCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilityProductData
     */
    purchaseCostEstimatedCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductProfitabilityProductData
     */
    purchaseCostComplete?: boolean;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ProductProfitabilityProductData
     */
    grossMargin?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ProductProfitabilityProductData
     */
    knownRevenue?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ProductProfitabilityProductData
     */
    knownPurchaseCost?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ProductProfitabilityProductData
     */
    knownGrossProfit?: NullableMoneyOutput | null;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilityProductData
     */
    knownLineCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilityProductData
     */
    unknownLineCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilityProductData
     */
    estimatedLineCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductProfitabilityProductData
     */
    partialAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductProfitabilityProductData
     */
    partialComplete?: boolean;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ProductProfitabilityProductData
     */
    allocatedMarketingSpend?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ProductProfitabilityProductData
     */
    profitAfterMarketing?: NullableMoneyOutput | null;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilityProductData
     */
    actionableUnknownLineCount?: number;
}

/**
 * Check if a given object implements the ProductProfitabilityProductData interface.
 */
export function instanceOfProductProfitabilityProductData(value: object): value is ProductProfitabilityProductData {
    return true;
}

export function ProductProfitabilityProductDataFromJSON(json: any): ProductProfitabilityProductData {
    return ProductProfitabilityProductDataFromJSONTyped(json, false);
}

export function ProductProfitabilityProductDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductProfitabilityProductData {
    if (json == null) {
        return json;
    }
    return {
        
        'productName': json['productName'] == null ? undefined : json['productName'],
        'integrationId': json['integrationId'] === undefined ? undefined : json['integrationId'] === null ? null : json['integrationId'],
        'productRemoteId': json['productRemoteId'] === undefined ? undefined : json['productRemoteId'] === null ? null : json['productRemoteId'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'turnover': json['turnover'] == null ? undefined : MoneyOutputFromJSON(json['turnover']),
        'purchasePrice': json['purchasePrice'] === undefined ? undefined : json['purchasePrice'] === null ? null : NullableMoneyOutputFromJSON(json['purchasePrice']),
        'purchaseCostUnknownCount': json['purchaseCostUnknownCount'] == null ? undefined : json['purchaseCostUnknownCount'],
        'purchaseCostEstimatedCount': json['purchaseCostEstimatedCount'] == null ? undefined : json['purchaseCostEstimatedCount'],
        'purchaseCostComplete': json['purchaseCostComplete'] == null ? undefined : json['purchaseCostComplete'],
        'grossMargin': json['grossMargin'] === undefined ? undefined : json['grossMargin'] === null ? null : NullableMoneyOutputFromJSON(json['grossMargin']),
        'knownRevenue': json['knownRevenue'] === undefined ? undefined : json['knownRevenue'] === null ? null : NullableMoneyOutputFromJSON(json['knownRevenue']),
        'knownPurchaseCost': json['knownPurchaseCost'] === undefined ? undefined : json['knownPurchaseCost'] === null ? null : NullableMoneyOutputFromJSON(json['knownPurchaseCost']),
        'knownGrossProfit': json['knownGrossProfit'] === undefined ? undefined : json['knownGrossProfit'] === null ? null : NullableMoneyOutputFromJSON(json['knownGrossProfit']),
        'knownLineCount': json['knownLineCount'] == null ? undefined : json['knownLineCount'],
        'unknownLineCount': json['unknownLineCount'] == null ? undefined : json['unknownLineCount'],
        'estimatedLineCount': json['estimatedLineCount'] == null ? undefined : json['estimatedLineCount'],
        'partialAvailable': json['partialAvailable'] == null ? undefined : json['partialAvailable'],
        'partialComplete': json['partialComplete'] == null ? undefined : json['partialComplete'],
        'allocatedMarketingSpend': json['allocatedMarketingSpend'] === undefined ? undefined : json['allocatedMarketingSpend'] === null ? null : NullableMoneyOutputFromJSON(json['allocatedMarketingSpend']),
        'profitAfterMarketing': json['profitAfterMarketing'] === undefined ? undefined : json['profitAfterMarketing'] === null ? null : NullableMoneyOutputFromJSON(json['profitAfterMarketing']),
        'actionableUnknownLineCount': json['actionableUnknownLineCount'] == null ? undefined : json['actionableUnknownLineCount'],
    };
}

export function ProductProfitabilityProductDataToJSON(json: any): ProductProfitabilityProductData {
    return ProductProfitabilityProductDataToJSONTyped(json, false);
}

export function ProductProfitabilityProductDataToJSONTyped(value?: ProductProfitabilityProductData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productName': value['productName'],
        'integrationId': value['integrationId'],
        'productRemoteId': value['productRemoteId'],
        'amount': value['amount'],
        'turnover': MoneyOutputToJSON(value['turnover']),
        'purchasePrice': NullableMoneyOutputToJSON(value['purchasePrice']),
        'purchaseCostUnknownCount': value['purchaseCostUnknownCount'],
        'purchaseCostEstimatedCount': value['purchaseCostEstimatedCount'],
        'purchaseCostComplete': value['purchaseCostComplete'],
        'grossMargin': NullableMoneyOutputToJSON(value['grossMargin']),
        'knownRevenue': NullableMoneyOutputToJSON(value['knownRevenue']),
        'knownPurchaseCost': NullableMoneyOutputToJSON(value['knownPurchaseCost']),
        'knownGrossProfit': NullableMoneyOutputToJSON(value['knownGrossProfit']),
        'knownLineCount': value['knownLineCount'],
        'unknownLineCount': value['unknownLineCount'],
        'estimatedLineCount': value['estimatedLineCount'],
        'partialAvailable': value['partialAvailable'],
        'partialComplete': value['partialComplete'],
        'allocatedMarketingSpend': NullableMoneyOutputToJSON(value['allocatedMarketingSpend']),
        'profitAfterMarketing': NullableMoneyOutputToJSON(value['profitAfterMarketing']),
        'actionableUnknownLineCount': value['actionableUnknownLineCount'],
    };
}

